module.exports = __webpack_public_path__ + "static/media/21ECLAC5.150c1342.jpg";